import { combineReducers } from '@reduxjs/toolkit';
import cache from './cache';
import data from './data';
import name from './name';
import query from './query';
import type from './type';
import value from './value';

const root = combineReducers({ value, data, cache, query, name, type });

export default root;

export type RulePageFiltersState = ReturnType<typeof root>;
